import { Swiper, EffectFade, Navigation, Pagination } from 'swiper'
import { createTitleTimeline } from '../animations'
import utils from '../utils'
import appUtils from '../app_utils'

Swiper.use([EffectFade])

// https://greensock.com/docs/v3/Installation
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const dataAttrSuffix = 'section-decor'
const dataAttr = 'data-' + dataAttrSuffix


class SectionDecor {
  constructor(target, args = {index: 0}) {
    this.target = target
    this.$el = $(this.target)

    this.titleTimeline = null
    this.$title = this.$el.find('[data-section-title]')

    this.$content = this.$el.find('[' + dataAttr + '-content]')
    this.contentScrollTrigger = null

    // this.$carousel = this.$el.find('[data-swiper]')
    this.$carousel = this.$el.find('[' + dataAttr + '-swiper]')
    this.$carouselPagination = this.$el.find('[' + dataAttr + '-swiper-pagination]')
    this.$carouselPaginationWrapper = this.$el.find('[' + dataAttr + '-swiper-pagination-wrapper]')

    this.carouselInstance = null
    this.carouselIniatialActiveIndex = 0

    // this.$setColorRadio = this.$el.find('[data-set-color]')
    this.$carouselControls = this.$el.find('[data-carousel-controls]')
    this.$carouselText = this.$el.find('[data-section-decor-text]')

    this.videoSection = this.target.querySelector('[data-section-decor-videosection]')
    this.video = this.target.querySelector('[data-video-wrapper] > video')

    this.id = dataAttrSuffix + '-' + args.index
    if(this.$el.attr('id')) {
      this.id = this.$el.attr('id')
    } else {
      this.$el.attr('id', this.id)
    }
    this.init()
  }

  addTimeline(item) {
    const images = item.querySelectorAll('[data-img-wrapper]')
    const captions = item.querySelectorAll('[data-caption]')
    const title = item.querySelector('[data-title]')
    const text = item.querySelector('[data-text]')
    const timeline = gsap.timeline()
    if (images) {
      timeline.call(()=>{
        images.forEach((image, k) => {
          image.classList.add('in-view-once')
        })
      }, [], '+=0')
    }

    if (captions) {
      timeline.from(captions, {
        y: 50,
        opacity: 0,
        duration: 0.5,
        stagger: 0.2
      }, "+=0.6")
    }


    if (text) {
      timeline.from(text, {
        opacity: 0,
        duration: 0.5,
      }, "+=0.3")
    }


    return timeline
  }

  init() {
    this.titleTimeline = createTitleTimeline(this.$title, true)
    const _self = this

    this.contentScrollTrigger = ScrollTrigger.create({
      trigger: this.$content,
      start: "top center",
      end: 'bottom top',
      toggleActions: 'play none none none',
      animation: this.addTimeline(this.$content[0])
    })

    // this.carouselInstance = this.$carousel.data('carousel-instance').swpInstance
    this.carouselInstance = new Swiper(this.$carousel[0], {
      modules: [Pagination],
      preloadImages: false,
      // allowTouchMove: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: this.$carouselPagination[0],
        clickable: true,
        renderBullet: function (index, className) {
          const slide = this.slides[index]
          // https://developer.mozilla.org/en-US/docs/Learn/HTML/Howto/Use_data_attributes
          const label = slide.dataset.slideTitle || (index + 1)
          const color = slide.dataset.slideColor
          return '<span  style="--bg-color: ' + color + ';" class="' + className + '"><span class="label">' + label + '</span></span>';
        },
      },
    })
    if (this.$carousel.attr('data-active-index')) {
      this.carouselIniatialActiveIndex = parseInt(this.$carousel.attr('data-active-index'), 10)
    }
    this.carouselInstance.activeIndex = this.carouselIniatialActiveIndex

    /*
    const setColor = function() {
      const index = $(this).attr('data-set-color')
      _self.carouselInstance.slideTo(index)
    }
    this.$setColorRadio.on('change', setColor)
    */


    this.video.onended = function() {
      _self.carouselInstance.enable()
      gsap.to(_self.$carouselPaginationWrapper, {opacity: 1})
    }

    this.videoScrollTrigger = ScrollTrigger.create({
      trigger: this.videoSection,
      start: "top bottom",
      end: 'bottom top',
      onEnter: ({progress, direction, isActive}) => {  // scroll position moves forward past the "start"
        _self.videoStart()
      },
      onEnterBack: ({progress, direction, isActive}) => { // scroll position moves backward past the "end"
        _self.videoStart()
      },
      onLeave: ({progress, direction, isActive}) => { // scroll position moves forward past the "end"
      },
      onLeaveBack: ({progress, direction, isActive}) => { // scroll position moves backward past the "start"
        // gsap.set(this.content, {opacity: 0}) // cover the $content

      },
    })

    this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.videoSection,
        start: "top 60%",
        // once: true,
        // toggleActions: 'play none play reverse',
      }
    })
    this.tl.fromTo(this.target.querySelectorAll('[data-tl-item]'), {opacity: 0, y: 30}, { opacity: 1, y: 0, stagger: 0.4, duration: 1 })
  }

  videoStart() {
    // this.$setColorRadio.filter(':checked').attr('checked', false)
    // this.$setColorRadio.first().click()
    this.carouselInstance.slideTo(this.carouselIniatialActiveIndex)
    this.video.currentTime = 0
    this.video.play()

    this.carouselInstance.disable()
    gsap.to(this.$carouselPaginationWrapper, {opacity: 0})
  }

  destroy() {
    if (this.titleTimeline) {
      this.titleTimeline.scrollTrigger.kill()
      this.titleTimeline.kill()
    }

    if (this.contentScrollTrigger) {
      this.contentScrollTrigger.animation.kill()
      this.contentScrollTrigger.kill()
    }

    if (this.carouselInstance) {
      this.carouselInstance.destroy()
    }

    if (this.videoScrollTrigger) {
      this.videoScrollTrigger.kill()
    }

    if (this.tl) {
      this.tl.scrollTrigger.kill()
      this.tl.kill()
    }

    // this.$setColorRadio.off('change')
  }
}

export default {dataAttr: dataAttr, sectionClass: SectionDecor}
